var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3660_5763)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73961 0.559398C9.09779 0.201221 9.58358 0 10.0901 0C10.3409 0 10.5893 0.0494011 10.821 0.145383C11.0527 0.241365 11.2633 0.382047 11.4406 0.559398C11.618 0.736749 11.7587 0.947295 11.8546 1.17902C11.9506 1.41074 12 1.65909 12 1.90991C12 2.16072 11.9506 2.40907 11.8546 2.64079C11.7587 2.87252 11.618 3.08306 11.4406 3.26041L3.50096 11.2001C3.42887 11.2722 3.33855 11.3233 3.23964 11.348L0 12L0.651992 8.76038C0.676718 8.66148 0.72786 8.57115 0.79995 8.49906L8.73961 0.559398ZM10.0901 1.125C9.88195 1.125 9.68231 1.2077 9.53511 1.35489L1.70561 9.18439L1.33561 10.6644L2.81564 10.2944L10.6451 2.46492C10.718 2.39203 10.7758 2.3055 10.8153 2.21028C10.8547 2.11505 10.875 2.01298 10.875 1.90991C10.875 1.80683 10.8547 1.70476 10.8153 1.60953C10.7758 1.51431 10.718 1.42778 10.6451 1.35489C10.5722 1.28201 10.4857 1.22419 10.3905 1.18475C10.2953 1.1453 10.1932 1.125 10.0901 1.125Z",
    fill: "#197A56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.875H5.25V12H12V10.875Z",
    fill: "#197A56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3660_5763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.8e29318aabc54dbda73e4bd2b51da735.svg";
export { ForwardRef as ReactComponent };